<template> 
  <div >
    <div >
        <!-- <table class="striped centered responsive-table">
            <thead>
                <tr>
                    <th>Vacancy Announcement Number</th>
                    <th>Job Title</th>
                    <th>Date of Issue</th>
                      <th> Deadline for Applications</th> 
                      <th>Organizational Unit</th>

                      <th>Duty Station</th>
                      <th>Duration of Assignment</th>
                      <th>Organizational context</th>
                      <th>Key results expected</th>
                      <th>Impact of Key results / KPI</th>

                      <th>Organizational Competencies</th>
                      <th>Tech/Functional Competencies</th>
                      <th>Educational Qualification</th>
                      <th>Experience</th>
                      <th>Language Requirements</th>

                      <th>Detailed terms of Reference: Download PDF file</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="data in careers">

                    <td>{{ data.vacancyAnnouncementNumber }}</td>
                    <td>{{ data.jobTitle }}</td>
                    <td>{{ data.dateofIssue }}</td>
                    <td>{{ data.deadlineforApplications }}</td>
                    <td>{{ data.organizationalUnit }}</td>

                    <td>{{ data.dutyStation }}</td>
                    <td>{{ data.durationofAssignment }}</td>
                    <td>{{ data.organizationalcontext }}</td>
                    <td>{{ data.keyresultsexpected }}</td>
                    <td>{{ data.impactofKeyresultsKPI }}</td>

                    <td>{{ data.organizationalCompetencies }}</td>
                    <td>{{ data.techFunctionalCompetencies }}</td>
                    <td>{{ data.educationalQualification }}</td>
                    <td>{{ data.experience }}</td>
                    <td>{{ data.languageRequirements }}</td>

                    <td v-for="download in data.Attachments">
                      <a :href="download.url">{{download.filename}}</a>
                    </td>
                </tr>
            </tbody>
        </table> -->
    </div>
    <br>
    <br>
     <div class="row">
    <div class="col s12 m12"  v-for="data in careers" :key="data.id">
      <div class="card ">
          <div class="vstf-card-content">
          <div class="col s4 m4">
        <span class="black-text">

                    <h6 class="vstf-card-content">{{$t('careers.vacancyAnnouncementNumber')}} : {{ data.vacancyAnnouncementNumber }}</h6>                          
                    <h6 class="vstf-card-content">{{$t('careers.jobTitle')}} : {{ data.jobTitle }} </h6>
                    <h6 class="vstf-card-content">{{$t('careers.dateOfIssue')}} : {{ data.dateofIssue }} </h6>
                    <h6 class="vstf-card-content"> {{$t('careers.deadlineForApplications')}} : {{ data.deadlineforApplications }}</h6> 
                    <h6 class="vstf-card-content">{{$t('careers.organizationalUnit')}} : {{ data.organizationalUnit }}</h6>
        </span>
        </div>
         <div class="col s4 m4">
        <span class="black-text">
            
                      <h6 class="vstf-card-content">{{$t('careers.dutyStation')}} : {{ data.dutyStation }} </h6>
                      <h6 class="vstf-card-content">{{$t('careers.durationOfAssignment')}} : {{ data.durationofAssignment }}</h6>
                      <h6 class="vstf-card-content">{{$t('careers.organizationalContext')}} : {{ data.organizationalcontext }}</h6>
                      <h6 class="vstf-card-content">{{$t('careers.keyResultsExpected')}} : {{ data.keyresultsexpected }} </h6>
                      <h6 class="vstf-card-content">{{$t('careers.impactOfKeyResultsKPI')}} : {{ data.impactofKeyresultsKPI }}</h6>
        </span>
        </div>
        
         <div class="col s4 m4">
        <span class="black-text">
                      <h6 class="vstf-card-content">{{$t('careers.organizationalCompetencies')}} : {{ data.organizationalCompetencies }} </h6>
                      <h6 class="vstf-card-content">{{$t('careers.techFunctionalCompetencies')}} : {{ data.techFunctionalCompetencies }}</h6>
                      <h6 class="vstf-card-content">{{$t('careers.educationalQualification')}} : {{ data.educationalQualification }}</h6>
                      <h6 class="vstf-card-content">{{$t('careers.experience')}} : {{ data.experience }}</h6>
                      <h6 class="vstf-card-content">{{$t('careers.languageRequirements')}} : {{ data.languageRequirements }}</h6>
        </span>
        </div>
        <br><br><br><br><br><br>
        
        </div>
        <div class="card-action">
          <a :href="data.detailedTermsOfReference.url" target="_black">{{$t('careers.detailedTermsOfReference')}} : {{data.detailedTermsOfReference.fileName}} </a>
        </div>
      </div>
    </div>
  </div>
         
</div>
</template>

<script>
import axiosCommon from '@/axios-common/axios-common';
export default {
name:'Careeres',
dependencies:['localeService'],
data () {
    return{
        careers:{}
    }
},
 mounted() {
        this.getCareeresData()
    },
      methods: {
            getCareeresData(){
                let vm = this;
               axiosCommon.get(`/o/careers?language=${vm.localeService.getCurrentLocale()}&`)
        .then(response => {
         this.careers = response.data
        })
        .catch(e => {
          console.log('Careeres')
          console.log(e)
        })
            }
      }
}
</script>

<style>
.card .vstf-card-content {
    padding: 24px;
    border-radius: 0 0 2px 2px;
    overflow-y: scroll;
    height: 100px;
    border-style: groove;
    border-radius: 10px;
    padding: 10px;
}
div.vstf-card-content{
    height: 100%!important;
}
</style>



// WEBPACK FOOTER //
// src/components/Careers/careers.vue